module.exports = __webpack_public_path__ + "img/1587195980.9f4c1239.jpg";